enum QuestionnaireResult {
    PositiveScreening,
    NegativeScreening,
    NotCompleted,
    MissingContactInfo
}

export { QuestionnaireResult };
